import React from 'react';
import { Star, CheckCircle2, Zap, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-10 pb-10 md:pt-14 md:pb-16 overflow-hidden bg-ocean-cream" data-id="element-80">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-82">
          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl order-2 lg:order-1 text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-83">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ocean-teal-light text-ocean-teal-dark text-xs sm:text-sm font-medium mb-4 lg:mb-6" data-id="element-84">
              <span aria-hidden="true" data-id="element-85">✨</span>
              SISTEMA PRÁCTICO DE REGULACIÓN DIARIA
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 lg:mb-6" data-id="element-86">
              El sistema integral para{' '}
              <span className="text-ocean-teal" data-id="element-87">bajar berrinches</span>, ordenar
              rutinas{' '}
              <span className="text-ocean-teal" data-id="element-88">y recuperar la calma</span> en
              casa
            </h1>

            <p className="text-base md:text-xl text-gray-600 mb-5 lg:mb-8 leading-relaxed" data-id="element-89">
              Herramientas visuales, guiones exactos y protocolos listos para
              usar con hijos con TDAH, TEA leve o dificultades de atención — sin
              teoría pesada ni improvisación diaria.
            </p>

            <div className="w-full flex flex-col sm:flex-row items-stretch sm:items-center justify-center lg:justify-start gap-4 mb-5 lg:mb-6" data-id="element-90">
              <button onClick={scrollToOffer} className="w-full sm:w-auto px-6 py-4 md:px-10 md:py-5 bg-ocean-teal hover:bg-ocean-teal-dark text-white rounded-2xl font-bold text-lg md:text-2xl transition-colors shadow-soft flex items-center justify-center gap-2" data-id="element-91">
                <span aria-hidden="true" data-id="element-92">🚀</span>
                ¡SÍ, QUIERO RECUPERAR LA PAZ!
              </button>
            </div>

            <div className="flex flex-col sm:flex-row sm:flex-wrap items-center justify-center lg:justify-start lg:items-center gap-x-4 gap-y-2 text-sm text-gray-500" data-id="element-93">
              <div className="flex items-center text-ocean-gold" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-95" />)}
              </div>
              <span data-id="element-96">4.9/5 — Reseñas verificadas</span>
              <span className="flex items-center gap-1" data-id="element-97">
                <CheckCircle2 className="w-4 h-4 text-ocean-teal" data-id="element-98" />
                Garantía de 7 días — Riesgo cero
              </span>
              <span className="flex items-center gap-1" data-id="element-99">
                <Zap className="w-4 h-4 text-ocean-gold-dark" data-id="element-100" />
                Acceso Inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-101">
                <Lock className="w-4 h-4 text-ocean-teal" data-id="element-102" />
                Pago a través de MercadoPago
              </span>
            </div>
          </motion.div>

          {/* Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex items-center justify-center mt-2 lg:mt-0 order-1 lg:order-2" data-id="element-103">
            <div className="relative w-full max-w-[300px] sm:max-w-sm lg:max-w-md" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/3aavACYim2F3MsgEyBWiCS/mockup_3.png" alt="Kit Calma Total — guía de regulación y TDAH con 3 bonos y el regalo especial Tablero Maestro" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-105" />

              {/* Top label */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-ocean-gold text-white text-xs sm:text-sm font-bold px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-106">
                Kit Calma Completo + Bonos
              </div>

              {/* Floating Regalo Incluido badge */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} className="absolute -bottom-3 -right-1 sm:-right-4 bg-white p-2.5 sm:p-4 rounded-2xl shadow-soft-lg border border-gray-50 flex items-center gap-2 sm:gap-3" data-id="element-107">
                <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-ocean-gold-light flex items-center justify-center shrink-0" data-id="element-108">
                  <span className="text-lg sm:text-2xl" aria-hidden="true" data-id="element-109">
                    🎁
                  </span>
                </div>
                <div data-id="element-110">
                  <p className="text-[10px] sm:text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-111">
                    Regalo Incluido
                  </p>
                  <p className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-112">
                    Tablero Maestro
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}